import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, Link } from 'react-router-dom';
import { VALIDATE_EMAIL } from '../../constants/constants'
import { getUserByEmail } from "../../actions/authAction";
import { useFormik } from 'formik';
import * as Yup from "yup";
import logo from '../../assets/icons/MetaBrief_horizontal_RBG.jpg'

const ForgotPassword = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    // const [email, setEmail] = useState(null)

    const { loading } = useSelector(state => state.getUserByEmail)

    const { isAuthenticated } = useSelector(state => state.auth)

    useEffect(() => {
        if (isAuthenticated) {
            history.push('/login')
        }
    }, [isAuthenticated, history])


    const formik = useFormik({
        initialValues: {
            email: '',
        },
        validationSchema: Yup.object({
            email: Yup.string().required('Email is required').matches(VALIDATE_EMAIL, "Email is not valid"),
        }),
        onSubmit: (value, { resetForm }) => {
            console.log('email', value)
            dispatch(getUserByEmail(value.email, history))
            //resetForm();
        },
    });

    return (
        <div id="wrapper" className="auth-m ain">
            <div className="container">
                <div className="row clearfix">
                    {/* <div className="col-12">
                        <nav className="navbar navbar-expand-lg">
                            <span className="navbar-brand" ><img src={logo} width="130" height="40" className="d-inline-block align-top mr-2" alt="" /></span>
                            <ul className="navbar-nav">
                                <li className="nav-item"><Link className="nav-link" to="/register">Register </Link></li>
                            </ul>
                        </nav>                    
                    </div> */}

                    <div className="col-md-4 mx-auto">
                        <div className="card custom_card border-radius-10">
                            <div className="header text-center pb-0">
                                <p className="lead"><span className="navbar-brand" ><img src={logo} width="110" height="auto" className="img-fluid mt-2" alt="" /></span></p>
                                <h4 className='login_text'><strong>Forgot Password</strong></h4>
                            </div>
                            <div className="body">
                                <p>Please enter your email address  to reset your password.</p>
                                {/* {error && <h6 className='text-danger'>{error}</h6>} */}
                                <form className="form-auth-small" onSubmit={formik.handleSubmit}>
                                    <div className="form-group relative_pos">
                                        {/* <input type="email" className="form-control" id="signup-password" placeholder="Email" required/> */}
                                        <span className='text_icon_input'><i className="icon-user"></i></span>
                                        <input type="text" name="email" {...formik.getFieldProps('email')} className="form-control custom_form_new" placeholder="Email" required />
                                        {formik.touched.email && formik.errors.email ? (
                                            <div className="text-danger p-1">{formik.errors.email}</div>
                                        ) : null}
                                    </div>
                                    <button type="submit" className="btn button btn-lg btn-block" disabled={loading ? true : false}>RESET PASSWORD</button>
                                    <div className="bottom text-center mt-3">
                                        <span className="helper-text ">Know your password? <Link to="/login">Login</Link></span>
                                    </div>
                                </form>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default ForgotPassword;
